import { useEffect, useState } from "react";
import PropertyCard from "../components/PropertyCard";
import { fetchProperties } from "../lib/api";

const CATEGORIES = ["All", "Apartment", "Penthouse", "Townhouse"];

export default function Properties() {
  const [properties, setProperties] = useState([]);
  const [filter, setFilter] = useState("All");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchProperties()
      .then((d) => { setProperties(d); setLoading(false); })
      .catch(() => setLoading(false));
  }, []);

  const filtered = filter === "All" ? properties : properties.filter((p) => p.category === filter);

  return (
    <div data-testid="properties-page" className="bg-[var(--ed-bg)]">
      {/* Editorial intro — matches the homepage visual language */}
      <section className="pt-32 lg:pt-40 pb-20">
        <div className="ed-container">
          <div className="max-w-3xl">
            <p className="ed-overline mb-5">The Residences</p>
            <h1 className="ed-display text-5xl sm:text-6xl lg:text-7xl mb-6">
              Stay <em>well.</em> Stay a while.
            </h1>
            <p className="ed-body">
              One quiet studio in Hammersmith, today. More on the way. Whether you&apos;re here for a
              week or a season, every residence is hosted, curated, and quietly run by the people
              who built it.
            </p>
          </div>
        </div>
      </section>

      <div className="ed-rule" />

      <section className="py-16 lg:py-20">
        <div className="ed-container">
          <div className="flex flex-wrap items-center gap-3 mb-12 pb-6 border-b border-[var(--ed-rule)]">
            <span className="ed-overline mr-4">Filter</span>
            {CATEGORIES.map((c) => (
              <button
                key={c}
                data-testid={`filter-${c.toLowerCase()}`}
                onClick={() => setFilter(c)}
                className={`text-[0.7rem] uppercase tracking-[0.22em] px-4 py-2.5 border transition-colors ${
                  filter === c
                    ? "bg-[var(--ed-ink)] text-[var(--ed-bg)] border-[var(--ed-ink)]"
                    : "border-[var(--ed-rule)] text-[var(--ed-ink-soft)] hover:border-[var(--ed-ink)] hover:text-[var(--ed-ink)]"
                }`}
              >
                {c}
              </button>
            ))}
            <span className="ml-auto text-[var(--ed-ink-muted)] text-sm" data-testid="results-count">
              {filtered.length} {filtered.length === 1 ? "residence" : "residences"}
            </span>
          </div>

          {loading ? (
            <p className="text-[var(--ed-ink-muted)] text-center py-20">Loading collection…</p>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-10">
              {filtered.map((p) => <PropertyCard key={p.id} property={p} />)}
            </div>
          )}

          {!loading && filtered.length === 0 && (
            <p className="text-[var(--ed-ink-muted)] text-center py-20">No residences match your filter.</p>
          )}
        </div>
      </section>
    </div>
  );
}
